var React = require('react');

function StepCircle0460px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm4.392-18h-1.656v-6.876h-11.16v-1.152L32.988 18.6h1.404v15.084h3.564v1.44h-3.564V42zm-10.764-8.316h9.108v-9.468c0-1.116.036-2.196.108-3.24l-.108-.036a27.69 27.69 0 0 1-1.836 2.952l-7.272 9.72v.072z"}));
}

StepCircle0460px.displayName = "StepCircle0460px";

StepCircle0460px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0460px;

StepCircle0460px.default = StepCircle0460px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-04-60px.svg
// module id = 1209
// module chunks = 0